

































import Vue from "vue";
import Component from "vue-class-component";
import Follow from "@/sites/user/pages/mypage/follow.vue";
import Profile from "@/sites/user/pages/mypage/profile.vue";
import qNotify from "@/common/qNotify";
@Component({
  name: "MyPageIndex",
  components: {
    Follow,
    Profile,
  },
})
export default class MyPageIndex extends Vue {
  selectComponent = "Profile";

  mounted() {
    const message = localStorage.getItem("error_same_line_id");
    console.log("Message", message);
    if (message) {
      qNotify.error({
        text: localStorage.getItem("error_same_line_id"),
      });
      localStorage.removeItem("error_same_line_id");
    }
  }

  get currentTabComponent() {
    return this.selectComponent;
  }

  currentTab(tabName) {
    return tabName === this.selectComponent ? "select" : "";
  }
}
